// extracted by mini-css-extract-plugin
export var aircallIframe = "_l5-3";
export var fabContainer = "_l5-5";
export var fabRinging = "_l5-6";
export var loadingOverlay = "_l5-4";
export var pulse = "_l5-7";
export var widgetContent = "_l5-2";
export var widgetPanel = "_l5-0";
export var widgetPanelExpanded = "_l5-1";